import { render } from "./Elemento_Tarifa.vue?vue&type=template&id=9d45ec1e"
import script from "./Elemento_Tarifa.vue?vue&type=script&lang=js"
export * from "./Elemento_Tarifa.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__